import type { DashboardActiveGoal, DashboardMetric } from '../../types/dashboard';

export type GoalsByMetric = Record<string, DashboardActiveGoal[]>;

export function collectGoalsByMetric(metrics: DashboardMetric[] | undefined): GoalsByMetric {
  const out: GoalsByMetric = {};
  for (const metric of metrics ?? []) {
    if (metric.goals?.active?.length) {
      out[metric.metricId] = metric.goals.active;
    }
  }
  return out;
}
